/** Read a field tolerating camelCase or PascalCase API payloads. */
export const pickRuleField = (obj, name) => {
  if (!obj) return undefined;
  const camel = name.charAt(0).toLowerCase() + name.slice(1);
  const pascal = name.charAt(0).toUpperCase() + name.slice(1);
  return Object.prototype.hasOwnProperty.call(obj, camel) ? obj[camel] : obj[pascal];
};

/**
 * Normalizes GET /payment/GetSubscriptionRules into a map keyed by plan id.
 * @param {object} response
 * @returns {Record<number, object>}
 */
export const buildRulesByPlan = (response) => {
  const rules = response?.rules ?? response?.Rules ?? [];
  const byPlan = {};
  (rules || []).forEach((rule) => {
    const planId = pickRuleField(rule, 'PlanId');
    if (planId != null) {
      byPlan[planId] = rule;
    }
  });
  return byPlan;
};

/**
 * VP cap for a plan from backend rules. Returns 0 when rules are not loaded.
 * @param {Record<number, object>|null|undefined} rulesByPlan
 * @param {number} planId
 * @returns {number}
 */
export const getVPLimitFromRules = (rulesByPlan, planId) => {
  if (!rulesByPlan || planId == null) return 0;
  const rule = rulesByPlan[planId];
  const limit = pickRuleField(rule, 'ValuePropositionLimit');
  return typeof limit === 'number' ? limit : 0;
};
